import { Suspense, useEffect } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const defaultQueryClient = new QueryClient();

type Props = {
  client?: QueryClient;
};

export const ShippoQueryClientProvider: React.FC<Props> = ({
  children,
  client = defaultQueryClient,
}) => {
  useEffect(() => {
    client.setDefaultOptions({
      queries: {
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
      },
    });
  }, [client]);
  return (
    <Suspense fallback="">
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </Suspense>
  );
};
